import useSWR from 'swr';

import { IPaginatedResponse } from 'utils/types';

import { fetcher } from './utils';

export const useAuditLogList = (url?: string | null, params: Record<string, any> = {}) => {
  const { data, isLoading, error, mutate, isValidating } = useSWR<IPaginatedResponse>(
    url ? { url, params } : null,
    fetcher
  );

  return { data: data?.data, meta: data?.meta, isLoading, error, mutate, isValidating };
};
